/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Observable } from "rxjs";
import { InjectionToken } from "@angular/core";
import { CurateSearchVm } from "libs/sysque/toolbelt/feature/src/lib/models/curate-search-vm";

export interface ICurateSearchFacade{
    notifySearchFor(curateSearchVm: CurateSearchVm, unitType: string): unknown;
    getCreateSearchOptions():Observable<any>;
    updateSelectorForResult():void;
    showRequestNewContent(): void;
    getLocalStorage(key: string): any;
}

export const CURATE_SEARCH_FACADE_TOKEN = new InjectionToken<ICurateSearchFacade>('CURATE_SEARCH_FACADE_TOKEN');